import {
  AddOfferResponseType,
  AddOfferType,
  ApplicationType,
  EditOfferType,
  OfferType,
  Page,
  ShortOfferType,
  SurveyAnswerType,
  ApplicationAccountType,
  OfferAnalytics,
  AddOfferExtendType,
} from "@jobintrans/base-ui.types.api"
import { API_URL, APIService } from "./APIService"

const getOffers = (page: number) =>
  APIService.get<null, Page<ShortOfferType>>(`/profiles/:profileId/offers?page=${page}`)
const addOffer = (offer: AddOfferType) =>
  APIService.post<
    null,
    {
      offerId: string
      transactionId: string
    }
  >(`/profiles/:profileId/offers`, offer)
const extendOffer = (id: string, body: AddOfferExtendType) =>
  APIService.patch<
    null,
    {
      offerId: string
      transactionId: string
    }
  >(`/profiles/:profileId/offers/${id}/extend`, body)
const editOffer = (id: string, offer: EditOfferType) =>
  APIService.patch<null, AddOfferResponseType>(`/profiles/:profileId/offers/${id}`, offer)
const getOffer = (id: string) =>
  APIService.get<null, OfferType>(`/profiles/:profileId/offers/${id}`)
const getOfferStatus = (id: string) =>
  APIService.get<
    null,
    {
      status: string
    }
  >(`/profiles/:profileId/offers/${id}/status`)
const getOfferApplications = (id: string, isNotRead: boolean, page: number, size?: number) =>
  APIService.get<null, Page<ApplicationType>>(
    `/profiles/:profileId/offers/${id}/applications?page=${page}&size=${
      size ?? 10
    }&isNotRead=${isNotRead}`,
  )
const getOfferApplicationAccount = (offerId: string, applicationId: string) =>
  APIService.get<null, ApplicationAccountType>(
    `${API_URL}/profiles/:profileId/offers/${offerId}/applications/${applicationId}/account`,
  )
const readOfferApplications = (offerId: string, applicationId: string) =>
  APIService.patch<null, null>(
    `/profiles/:profileId/offers/${offerId}/applications/${applicationId}/read`,
  )
const getOfferApplicationFile = (offerId: string, applicationId: string) =>
  APIService.get<null, any>(
    `${API_URL}/profiles/:profileId/offers/${offerId}/applications/${applicationId}/file`,
    {
      responseType: "blob",
    },
  )
const getOfferApplicationSurvey = (offerId: string, applicationId: string) =>
  APIService.get<null, SurveyAnswerType>(
    `${API_URL}/profiles/:profileId/offers/${offerId}/applications/${applicationId}/survey`,
  )
const getOfferToExtend = (id: string) =>
  APIService.get<null, OfferType>(`/profiles/:profileId/offers/${id}/extend`)
const boostOffer = (id: string) =>
  APIService.patch<null, ShortOfferType>(`/profiles/:profileId/offers/${id}/boost`)
const getAnalytics = (id: string) =>
  APIService.get<null, OfferAnalytics>(`/profiles/:profileId/offers/${id}/analytics`)

export const ProfileOfferService = {
  addOffer,
  extendOffer,
  getOffer,
  editOffer,
  getOfferStatus,
  getOfferApplications,
  getOfferApplicationFile,
  getOfferApplicationSurvey,
  getOfferApplicationAccount,
  getOfferToExtend,
  readOfferApplications,
  boostOffer,
  getAnalytics,
  getOffers,
}
